import formatClass from './chartTipFormat';
export default {
  /*图表tooltip自定义*/
  formatterTip (params, context) {
    function notEmpty (num) {
      if (num === 0) {
        return true
      } else {
        return new Boolean(num).valueOf()
      }
    }
    // monitor,daily summary,day by day三个页面的图形标注
    let tipArray = [], tip = '', timeDetail = '', basalValue = '', tempList = {}
    // 过滤重复的basal、tempBasal数据
    let cleanParam = params.filter(item => {
      if (notEmpty(item.value[1]) || notEmpty(item.value[2])) {
        if (item.seriesName === context.$t('basal')) {
          // 舍掉一个temp和basal值相同的记录
          basalValue = item.value[1]
          return true
        } else if (item.seriesName === context.$t('tempBasal')) {
          tempList['' + item.value[1]] = item
        } else {
          return true
        }
      }
    })
    if (Object.entries(tempList).length === 1) {
      cleanParam.push(Object.values(tempList)[0])
    } else if (Object.entries(tempList).length > 1) {
      Object.entries(tempList).map(([key, value]) => {
        if(+key !== +basalValue){
          cleanParam.push(value)
        }
      })
    }
    cleanParam.map(function (e) {
      if (e.value[0] !== 10) {
        let name = e.seriesName;
        let value = e.value;
        timeDetail = formatClass.getFormatterTip1TimeDetail(e.value[0])
        // 利用map对不同图进行匹配
        let chartFormatMap = new Map([
          [context.$t('basal'), formatClass.basalFormat],
          [context.$t('auto suspend'), formatClass.autosuspendFormat],
          [context.$t('tempBasal'), formatClass.basalFormat],
          [context.$t('manualStop'), formatClass.manualStopFormat],
          [context.$t('normalBolus'), formatClass.normalBolusFormat],
          [context.$t('extendBolus'), formatClass.extendBolusFormat],
          [context.$t('newPatch'), formatClass.newPatchFormat],
          [context.$t('stop'), formatClass.stopFormat],
          [context.$t('alert'), formatClass.alertFormat],
          [context.$t('t1222_autoModeBasal'), formatClass.autoModeBasalFormat],
          [context.$t('t1222_autoModeCorrBolus'), formatClass.autoModeCorrBolusFormat],
        ])
        tipArray.push(chartFormatMap.get(name).call(formatClass, value, name, context))
      }
    });
    tip = tip + timeDetail;
    // 可能会出现空值和重复值
    let resMap = new Map();
    tipArray.map(function (e, i) {
      if (e) {
        resMap.set(e, resMap.get(e) || 1)
      }
    });
    for (let item of resMap.keys()) {
      tip = tip + item + '<br>';
    }
    return tip;
  },
  formatterTip1 (params, context) {
    let tipArray = [], tip = '', timeDetail = '';
    params.map(function (e) {
      if (e.value[0] !== 10) {
        const name = e.seriesName;
        timeDetail = formatClass.getFormatterTip1TimeDetail(e.value[0])
        const chartFormatMap = new Map([
          ['SG', formatClass.SGFormat],
          ['calib', formatClass.calibFormat],
          ['bg', formatClass.bgFormat],
          ['transmtr', formatClass.transmtrFormat],
          ['alarm', formatClass.alarmFormat],
        ])
        tipArray.push(chartFormatMap.get(name)(e, context))
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });
    //console.log('tip1:', tip);
    return tip;
  },
  formatterTip3 (params, context) {
    // console.log(params);
    let that = this;
    let tipArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], tip = '', timeDetail = '', unit = (context.isMg) ? 'mg/dL' : 'mmol/L ';
    let icon0 = " <div style='background: #3ce8dc;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let icon1 = " <div style='background: #2842d2;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let icon2 = " <div style='background: #79bd39;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let icon3 = " <div style='background: #dce573;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let icon4 = " <div style='background: #e61795;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let icon5 = " <div style='background: #c9711e;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let icon6 = " <div style='background: #a922d9;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let icon7 = " <div style='background: #464646;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    params.map(function (e, i) {
      let index = e.seriesIndex;
      let value = e.value[1];
      let date = e.value[0];
      let time = that.formatterDate5(date);
      let t1 = '';
      timeDetail = context.$t('SG') + ' ' + time[0] + ':' + time[1] + '<br>';
      if (index < 8) {
        let type = e.value[2], tip0 = '', ico = icon0;
        if (index < 7) {
          let t2 = context.legendDate[index].split('-');
          t1 = t2[0] + '/' + t2[1];
        }
        else {
          t1 = context.$t('Avg');
        }
        ico = (index === 1) ? icon1 : ico; ico = (index === 2) ? icon2 : ico; ico = (index === 3) ? icon3 : ico;
        ico = (index === 4) ? icon4 : ico; ico = (index === 5) ? icon5 : ico; ico = (index === 6) ? icon6 : ico; ico = (index === 7) ? icon7 : ico;
        if (value > 0) {
          let value1 = '';

          //  显示 High Low
          let isHighLow = true;

          try {
            //console.log('monitor sg tip:', value, typeof(value));
            let sg_val = parseFloat(value);
            if (context.isMg) {
              if (sg_val >= 400) {
                value = 'High';
              } else if (sg_val <= 40) {
                value = 'Low';
              } else {
                isHighLow = false;
              }
            } else {
              if (sg_val >= 22.2) {
                value = 'High';
              } else if (sg_val <= 2.2) {
                value = 'Low';
              } else {
                isHighLow = false;
              }
            }
            //console.log('monitor sg tip:', value, isHighLow);
          } catch (e) {
            console.log('sg tip:', e)
          }

          if (type === 'CX' || type === 'NC') {
            let top1 = 45 * (index + 1) + 'px';
            let hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:65px;;position: absolute;top:"' + top1 + '>';
            let hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:90px;;position: absolute;top:"' + top1 + '>';
            value1 = (context.isEn) ? value + hr1 : value + hr1;
          } else {
            value1 = value;
          }
          if (isHighLow) {
            tip0 = ico + t1 + ' : ' + value1;
          } else {
            tip0 = ico + t1 + ' : ' + value1 + unit;
          }
        }
        else {
          let text = '';
          if (type === 'NC') { text = context.$t('Not Calibrated'); }
          if (type === 'DE') { text = context.$t('noReadings'); }
          if (type === 'CE0' || type === 'CE1') { text = context.$t('Calibration Error'); }
          if (type === 'H') { text = context.$t('warm'); }
          tip0 = ico + t1 + ' : ' + text;
        }
        tipArray[index] = tip0;
      }
      if (index === 8) {
        let icon8 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        tipArray[8] = icon8 + context.$t('calib') + ' : ' + value + unit;
      }
      if (index === 9) {
        let icon8 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
        tipArray[9] = icon8 + context.$t('BG') + ' : ' + value + unit;
      }
    });
    tip = tip + timeDetail;
    tipArray.map(function (e, i) {
      if (e) {
        tip = tip + e + '<br>';
      }
    });
    return tip;
  },
  //时间格式化
  formateDate (date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let mi = date.getMinutes();
    let s = date.getSeconds();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    mi = mi < 10 ? ('0' + mi) : mi;
    return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate1 (date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let mi = date.getMinutes();
    let s = date.getSeconds();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    h = h < 10 ? ('0' + h) : h;
    mi = mi < 10 ? ('0' + mi) : mi;
    s = s < 10 ? ('0' + s) : s;
    return d + '-' + m + '-' + y + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate1a (date) {
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let mi = date.getMinutes();
    let s = date.getSeconds();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    h = h < 10 ? ('0' + h) : h;
    mi = mi < 10 ? ('0' + mi) : mi;
    s = s < 10 ? ('0' + s) : s;
    return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
  },
  formatterDate2 (val) {
    let time = new Date(val * 1000);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    return d + '/' + m + '/' + y;
  },
  formatterDate3 (val) {
    let time = new Date(val * 1000);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
  },
  formatterDate4 (val) {
    let time = new Date(val * 1000);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    return d + '-' + m + '-' + y;
  },
  formatterDate4_1 (val) {
    let time = new Date(val * 1000);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    //m = m<10 ? ('0'+m ): m;
    //d = d<10 ? ('0'+d) : d;
    return d + '-' + m;
  },
  formatterDate5 (val) {
    let h = val.getHours();
    let mi = val.getMinutes();
    h = h < 10 ? ('0' + h) : h;
    mi = mi < 10 ? ('0' + mi) : mi;
    return [h, mi];
  },
  formatterDate6 (val) {
    let date = new Date(val * 1000);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let mi = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    h = h < 10 ? ('0' + h) : h;
    mi = mi < 10 ? ('0' + mi) : mi;
    return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
  },
  formatterDate7 (context, val) {
    if (!val) {
      return '--';
    }
    let date = new Date(val * 1000);
    let now = new Date().getDate();
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let mi = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    h = h < 10 ? ('0' + h) : h;
    mi = mi < 10 ? ('0' + mi) : mi;
    if (now === parseInt(d)) {
      return context.$t('Today') + ' ' + h + ':' + mi;
    } else if ((now - 1) === parseInt(d)) {
      return context.$t('Yesterday') + ' ' + h + ':' + mi;
    } else {
      return d + '/' + m + '/' + y + ' ' + h + ':' + mi;
    }

  },
  formatterDate8 (val) {
    let time = new Date(val * 1000);
    let m = time.getMonth() + 1;
    let d = time.getDate();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    return d + '/' + m;
  },
  formatterDate9 (val) {
    let time = new Date(val * 1000);
    let y = time.getFullYear();
    let m = time.getMonth();
    let d = time.getDate();
    return [parseInt(y), parseInt(m), parseInt(d)];
  },
  formatterDate10 (val) {
    let time = new Date(val * 1000);
    let h = time.getHours();
    let m = time.getMinutes();
    let s = time.getSeconds();
    return [parseInt(h), parseInt(m), parseInt(s)];
  },
  formatterDay (context, val) {
    let time = new Date(val * 1000);
    let week = new Array(context.$t('Sun'), context.$t('Mon'), context.$t('Tue'), context.$t('Wed'), context.$t('Thur'), context.$t('Fri'), context.$t('Sat'));
    let day = time.getDay();
    return week[day];
  },
  formatterDateHCL (val) {
    let time = new Date(val * 1000);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    m = m < 10 ? ('0' + m) : m;
    d = d < 10 ? ('0' + d) : d;
    return y + '/' + m + '/' + d;
  },
  /**
   * 
   * @param {*} unconvertTime 未转换时区的时间
   * @param {*} Zone 时区信息，可为空、数字、负数
   * @returns 转换后的时间
   */
  convertTimeZone (unconvertTime, Zone) {
    let offset = Zone.match(/[\d]+$/g)
    if (offset && Zone[0] === '-') {
      offset = -offset
    }
    return new Date(unconvertTime.getTime() + unconvertTime.getTimezoneOffset() * 60000 + offset * 3600000)
  },
}



// WEBPACK FOOTER //
// ./src/lib/format.js